import classNames from 'classnames';
import { useMemo } from 'react';

export const BASE_NAME = process.env.REACT_APP_HOME_PAGE;

type MediaSource = {
	media: string;
	srcSet: string;
};

type BrandProps = {
	readonly alt?: string;
	readonly className?: string;
	readonly mediaSources?: MediaSource[];
	readonly src: string;
};

const classNameComponente = 'c-pin-image-media';

export const ImageMedia = ({ alt, className, mediaSources = [], src }: BrandProps) => {
	const imageMediaClassName = useMemo(() => classNames(className, classNameComponente), [className]);

	return (
		<picture className={imageMediaClassName}>
			{mediaSources.map(({ media, srcSet }) => (
				<source key={src} media={media} srcSet={`${BASE_NAME}${srcSet}`} />
			))}
			<img className={`${classNameComponente}__img`} src={`${BASE_NAME}${src}`} alt={alt} />
		</picture>
	);
};
